const trustItems = [
  { icon: 'ri-refresh-line', label: 'Updated Daily' },
  { icon: 'ri-store-2-line', label: 'Thousands of Products' },
  { icon: 'ri-shield-check-line', label: 'Verified Sellers' },
  { icon: 'ri-zoom-in-line', label: 'QC Guides' },
  { icon: 'ri-ship-line', label: 'Shipping Tutorials' },
];

export default function TrustBar() {
  return (
    <section className="w-full bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-5">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-foreground-600">
              <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className={`${item.icon} text-base`}></i>
              </span>
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}